<template>
  <div class="html-content break-word" v-if="htmlContent === null || htmlContent.trim() === ''"></div>
  <div v-else class="html-content break-word" v-html="htmlContent.replace(/<p>/g, `<p style='margin-bottom: 0'>`)"></div>
</template>

<script>
export default {
  name: "DisplayModeVueEditor",
  props : {
    htmlContent: String,
    default: ''
  },
}
</script>

<style scoped>
.html-content {
  border: 1px solid #ccc;
  padding: 12px 15px;
  min-height: 200px;
  margin-bottom: 4px;

  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
